import { Grid, Stack } from '@mui/material'
import { FC, useContext } from 'react'

import ShopContactBox from '../../components/CustomerPortal/ShopContactBox'
import ServicesSummaryPanel from '../../components/InspectionRelatedPanel/ServicesSummaryPanel'
import SummaryPanel from '../../components/SharedUI/SummaryPanel/SummaryPanel'
import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import PaymentCreated from './PaymentCreated'
import { PaymentForm } from './PaymentForm'
import useExistingPayment from './useExistingPayment'

const DesktopPortalBody: FC = () => {
  const { repairOrder, services, shop } = useContext(PaymentPortalContext)
  const existingPayment = useExistingPayment()

  return (
    <Stack spacing={2}>
      {existingPayment ? (
        <PaymentCreated payment={existingPayment} />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={8}>
            <Stack spacing={2}>
              <ShopContactBox shop={shop!} />
              <ServicesSummaryPanel services={services!} showPrice />
              <SummaryPanel repairOrder={repairOrder!} readOnly />
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <PaymentForm />
          </Grid>
        </Grid>
      )}
    </Stack>
  )
}

export default DesktopPortalBody
